(function ($) {

    $(window).on('load', function () {
        if ($('.js_latest_news_about, .events-grid-slider').length > 0) {
            setTimeout(function () {
                $(".events-grid-slider .row-wrap").css({"opacity": "1"});
            }, 500);
        }
        var sliderLength = $('.events-grid-slider .row-wrap .col-three').length;
        if (sliderLength > 3) {
            //$('.events-grid-slider .row-wrap .views-element-container > div').slick({
            $('.events-grid-slider .row-wrap').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }
                ]
            });
            //   $('.events-grid-slider .row-wrap').slick({
            //     slidesToShow: 3,
            //     slidesToScroll: 1,
            //     dots: false,
            //     arrows: true,
            //     infinite: false,
            //     cssEase: 'linear',
            //     responsive: [
            //         {
            //             breakpoint: 991,
            //             settings: {
            //                 slidesToShow: 2
            //             }
            //         },
            //         {
            //             breakpoint: 767,
            //             settings: {
            //                 slidesToShow: 1,
            //                 draggable: true
            //             }
            //         }
            //     ]
            // });
        }

    });
    $(".events-grid-slider .col-three .text-wrap h5").dotdotdot({
        height: 60,
        fallbackToLetter: true,
        watch: true,
    });
    $(window).on('orientationchange', function () {
        setTimeout(function () {
            $('.events-grid-slider .row-wrap .views-element-container > div').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }
                ]
            });
        }, 300);

    });

})(jQuery);
